// extracted by mini-css-extract-plugin
export default {"titleArea":"Category_titleArea__AS6BI","title":"Category_title__QFCoG"};